import React from "react";
import contextProvider from "app/contextProvider";
import { Row, Col, CustomInput } from "reactstrap";
import { Link } from "react-router-dom";
import ReactOTooltip from "app/_L1_components/Elements/ReactOTooltip";
import _ReactOBaseComponent from "app/_L0_components/_ReactOBaseComponent";
import Panel from "app/_L1_components/Layout/Panel";
import { _LoadingWrapper } from "app/_L0_components/Widgets/_LoadingKit";
import Highlighter from "react-highlight-words";

class StepViewer extends _ReactOBaseComponent {
  constructor(props) {
    super(props);
    this._logCat = "";
  }

  state = {
    loading: true,
    opened: false,
  };

  toggle() {
    this.setState({
      opened: !this.state.opened,
    });
  }

  onComponentDidMount() {
    this.apiStore = this.getAppContext().getApiStoreService();
    const urlParams = new URLSearchParams(window.location.search);
    this.urlData = JSON.parse(urlParams.get("data"));
    console.log("this.urlData", this.urlData);
    if (this.urlData.plainText) {
      this.setState({ logData: this.urlData.plainText }, () =>
        this.processData(this.urlData.plainText)
      );
    } else {
      this.setState(
        {
          loading: true,
        },
        () => {
          this.apiStore.fire("get_measure_results", {
            data: this.urlData.api,
            ___onSuccess: (status, data) => {
              let filtered = "";
              if (this.urlData.ref.name && this.urlData.ref.final == false) {
                filtered = data.measureResults[
                  this.urlData.ref.selectedResult
                ].steps.filter((value) => {
                  return value.name == this.urlData.ref.name;
                })[0].result;
                // filtered = rawRes[0];
              } else if (this.urlData.ref.final == true) {
                filtered =
                  data.measureResults[this.urlData.ref.selectedResult].end;
              }

              this.setState({
                allData: data,
                logData: filtered,
                loading: false,
              });
              this.processData(filtered);
            },
          });
        }
      );
    }
  }

  processData(text) {
    const { search = "", searchLength = "" } = this.state;
    let _checkedRow = false;
    let infoColorClass = null;
    let matchCounter = 0;
    // let _number = number || searchNumber;
    let formatted = text.split("\n").filter((row) => {
      if (search && search[0].test(row)) {
        if (searchLength > 0) {
          _checkedRow = true;
          infoColorClass = "";
          matchCounter += row.match(search[0]).length;
        }
        return search[0].test(row);
      } else return !search;
    });

    if (this.state.regexError && this.state.regexError == true) {
      infoColorClass = "text-danger";
    }
    if (formatted.length == 0) {
      _checkedRow = false;
      this.setState({
        infoText: "No matches",
        infoColorClass: null,
      });
    }
    // this.typeFirstTypeName = Object.values(this.typeList[0].name).join("");
    this.setState({
      // log: text,
      loading: false,
      formatted: formatted,
      matchCounter: matchCounter,
      checkedRow: _checkedRow,
      // typeList: typeList,
      infoColorClass: infoColorClass,
    });
  }

  delay(time, string) {
    if (time == this.globalTime) {
      // && this.manualSearch == false per manual fire
      try {
        var regex = [new RegExp(string, "ig")];
        if (string.length == 0) {
          this.setState({
            checkedRow: false,
            infoText: "",
            search: regex,
            regexError: false,
            searchLength: string.length,
          });
        } else {
          this.setState({
            search: regex,
            searchLength: string.length,
            regexError: false,
          });
        }
        this.processData(this.state.logData);
      } catch (e) {
        this.setState({
          // search: new RegExp(""),
          checkedRow: false,
          regexError: true,
          infoText: "Pattern error",
          infoColorClass: "text-danger",
          // searchLength: string.length,
        });
        // this.processData();
        return false;
      }
    }
  }

  onRender() {
    return (
      <_LoadingWrapper minHeight loadingPlug={this.state.loading}>
        {this.state.formatted && this.state.err == undefined ? (
          <div className="wrapper_log bg-light">
            <div className="px-3 pt-3 pb-2 border-bottom border-3 border-primary header-logcat">
              <Row>
                {!this.urlData.plainText ? (
                  <Col>
                    <h5>
                      <Link
                        to={this.urlData?.ref?.originUrl || "#"}
                        className="header-link_log"
                      >
                        {this.state.allData.name || "CVE"}{" "}
                      </Link>
                      <span className="icon-navigate-next align-middle mx-1" />{" "}
                      {this.urlData?.ref?.final ? (
                        <span>
                          <span>End of measure</span>
                          <span className="icon-navigate-next align-middle mx-1" />
                          <span id="_tooltip_header">
                            {" "}
                            {this.getAppContext()
                              .momentjs(
                                this.state.allData.measureResults[
                                  this.urlData.ref.selectedResult
                                ].etime,
                                "X"
                              )
                              .format("LTS")}
                            <span className="sub-title icon-info ml-2" />
                          </span>
                        </span>
                      ) : (
                        <span>
                          <span>{this.urlData?.ref?.phase[0] || ""}</span>
                          <span className="icon-navigate-next align-middle mx-1" />
                          <span id="_tooltip_header">
                            {" "}
                            {this.getAppContext()
                              .momentjs(
                                this.state.allData?.measureResults[
                                  this.urlData?.ref?.selectedResult
                                ].etime,
                                "X"
                              )
                              .format("LTS")}
                            <span className="sub-title icon-info ml-2" />
                          </span>
                        </span>
                      )}
                    </h5>
                    <ReactOTooltip
                      placement="bottom"
                      target="_tooltip_header"
                      text={
                        <div className="text-left text-nowrap">
                          <strong>DATE:</strong>

                          <span className="text-muted ml-2">
                            {this.getAppContext()
                              .momentjs(
                                this.state.allData.measureResults[
                                  this.urlData.ref.selectedResult
                                ].etime,
                                "X"
                              )
                              .format("L LTS")}
                          </span>
                        </div>
                      }
                    />
                    <div className="sub-title my-auto pt-2 pl-2">
                      <span className="pr-2 border-right">
                        <strong>PROBE:</strong>{" "}
                        {this.state.allData.prb_id
                          .replace(/(..)/g, "$1:")
                          .slice(0, -1)}
                      </span>

                      <span className="px-2 ">
                        <strong>BSSID:</strong>{" "}
                        <span id="_tooltip_bssid">
                          {/ethernet/i.test(this.state.allData.essid)
                            ? "Ethernet"
                            : this.state.allData.measureResults[
                                this.urlData.ref.selectedResult
                              ].bssid_info.ap_custom_data
                            ? this.state.allData.measureResults[
                                this.urlData.ref.selectedResult
                              ].bssid_info.ap_custom_data.name
                            : this.state.allData.measureResults[
                                this.urlData.ref.selectedResult
                              ].bssid
                            ? this.state.allData.measureResults[
                                this.urlData.ref.selectedResult
                              ].bssid
                            : "-"}
                          {/ethernet/i.test(this.state.allData.essid) ? null : (
                            <span className="sub-title icon-info ml-2" />
                          )}
                        </span>
                      </span>

                      {/ethernet/i.test(this.state.allData.essid) ? null : (
                        <ReactOTooltip
                          placement="bottom"
                          target="_tooltip_bssid"
                          text={
                            this.state.allData.measureResults[
                              this.urlData.ref.selectedResult
                            ].bssid_info.ap_custom_data &&
                            this.state.allData.measureResults[
                              this.urlData.ref.selectedResult
                            ].bssid_info.ap_custom_data.name ? (
                              <div className="text-left text-nowrap">
                                <strong>
                                  {
                                    this.state.allData.measureResults[
                                      this.urlData.ref.selectedResult
                                    ].bssid_info.ap_custom_data.name
                                  }
                                  :
                                </strong>

                                <span className="text-muted ml-2">
                                  {this.state.allData.measureResults[
                                    this.urlData.ref.selectedResult
                                  ].bssid
                                    ? this.state.allData.measureResults[
                                        this.urlData.ref.selectedResult
                                      ].bssid
                                    : "-"}
                                </span>
                              </div>
                            ) : (
                              <div className="text-left text-nowrap">
                                <strong>
                                  {this.state.allData.measureResults[
                                    this.urlData.ref.selectedResult
                                  ].bssid
                                    ? this.state.allData.measureResults[
                                        this.urlData.ref.selectedResult
                                      ].bssid
                                    : "-"}
                                </strong>
                                {this.state.allData.measureResults[
                                  this.urlData.ref.selectedResult
                                ].bssid_info.long_desc ? (
                                  <span>
                                    {" - " +
                                      this.state.allData.measureResults[
                                        this.urlData.ref.selectedResult
                                      ].bssid_info.long_desc}
                                  </span>
                                ) : null}
                              </div>
                            )
                          }
                        />
                      )}
                      {!this.urlData.ref.final ? (
                        <span>
                          <span className="px-2 border-left border-right">
                            <strong>STATUS:</strong>{" "}
                            {/^(\d+)$/.test(this.urlData.ref.phase[1]) ? (
                              <strong className="icon-check1 text-success" />
                            ) : (
                              <strong className="icon-close-outline text-danger" />
                            )}
                          </span>

                          <span className="px-2">
                            <strong>TIME:</strong>{" "}
                            {/^(\d+)$/.test(this.urlData.ref.phase[1])
                              ? this.urlData.ref.phase[1]
                              : "-"}{" "}
                            ms
                          </span>
                        </span>
                      ) : null}
                    </div>
                  </Col>
                ) : (
                  <Col>
                    <h5>CVE Test Results</h5>
                  </Col>
                )}

                <div className="d-flex my-auto justify-content-end mr-3">
                  <CustomInput
                    type="switch"
                    className="mt-2 label-logcat-wrap"
                    size="sm"
                    id="exampleCustomCheckbox2"
                    // label="Wrap text"
                    onClick={() => {
                      this.setState({
                        classWrapText: !this.state.classWrapText,
                      });
                    }}
                  />
                  <label className="my-auto pt-1 label-logcat-wrap">
                    <span>WRAP TEXT</span>
                  </label>
                </div>

                <Col
                  className="d-flex justify-content-end mt-3 mt-lg-0"
                  style={{ maxWidth: "400px" }}
                >
                  <input
                    className="form-input-text my-auto form-control-sm form-control"
                    type="text"
                    // size="sm"
                    placeholder="Regex..."
                    onChange={(e) => {
                      this.globalTime = Date.now();
                      let singleTime = Date.now();
                      let string = e.target.value;
                      setTimeout(() => {
                        this.delay(singleTime, string);
                      }, 1200);
                    }}
                  />{" "}
                  <span
                    className={
                      this.state.infoColorClass != null
                        ? "sub-title my-auto text-right " +
                          this.state.infoColorClass
                        : "sub-title my-auto text-right"
                    }
                    style={
                      this.getAppContext().media.isDesktopXl
                        ? { width: "285px" }
                        : { width: "240px" }
                    }
                  >
                    <strong>
                      {" "}
                      {this.state.checkedRow == true
                        ? this.state.matchCounter + " matches"
                        : this.state.infoText}
                    </strong>
                  </span>
                </Col>
              </Row>
            </div>
            <div
              id="container-logcat"
              className={`horizontal-scroll bg-dark text-light ${
                // bg-dark text-light
                this.state.classWrapText ? "text-log-wrap" : "text-log-no-wrap"
              } pt-2`}
              style={{
                height: `${window.innerHeight - 100}px`,
              }}
            >
              {this.state.formatted.map((row, id) => {
                return (
                  <div className="item" key={id}>
                    {" "}
                    <Highlighter
                      highlightClassName="background-highlight"
                      searchWords={this.state.search ? this.state.search : []}
                      autoEscape={false}
                      textToHighlight={row}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        ) : this.state.err == true ? (
          <Panel className="mx-4 my-4" bodyClassName="p-0" rounded>
            <div className="py-4 ml-2"> No logcat available</div>
          </Panel>
        ) : null}
      </_LoadingWrapper>
    );
  }
}

export default contextProvider(StepViewer, {
  define: null,
});
